import {
  Component,
  Input,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-template9',
  templateUrl: './template9.component.html',
  styleUrls: ['./template9.component.scss'],
})
export class Template9Component {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef })
  sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  ngOnInit(): void {}
}
